import IconPublic from '@/components/assets/icon_language.svg'
import IconUnlisted from '@/components/assets/icon_link.svg'
import IconPrivate from '@/components/assets/icon_lock.svg'
import { Policy, PolicyOption } from '@/types/world'
import { useTranslations } from 'next-intl'

export const useRoomPolicy = (): Record<Policy, PolicyOption> => {
  const t = useTranslations()

  const ROOM_POLICY: Record<Policy, PolicyOption> = {
    public: {
      value: 'allow_any_user',
      title: t('profile-page.my-worlds-create-option-1-title'),
      description: t('profile-page.my-worlds-create-option-1-desc'),
      Icon: IconPublic,
    },
    unlisted: {
      value: 'unlisted',
      title: t('profile-page.my-worlds-create-option-2-title'),
      description: t('profile-page.my-worlds-create-option-2-desc'),
      Icon: IconUnlisted,
    },
    private: {
      value: 'owner_only',
      title: t('profile-page.my-worlds-create-option-3-title'),
      description: t('profile-page.my-worlds-create-option-3-desc'),
      Icon: IconPrivate,
    },
  }

  return ROOM_POLICY
}
